import { apiGet, apiPutVoid } from "@/core/api";
import { isNetworkAdmin, sessionState } from "@/core/session";
export const apiUserSettings = {
    generateMfaSecret: () => apiGet(`/auth/mfaSecret`),
    setMfaSecret: (req) => apiPutVoid(`/auth/mfaSecret`, req),
    updatePreferences: (preferences) => {
        if (isNetworkAdmin()) {
            apiPutVoid(`networkUsers/${sessionState.session.user.id}/preferences`, preferences);
        }
        else {
            apiPutVoid(`partnerUsers/${sessionState.session.user.id}/preferences`, preferences);
        }
    }
};
